import { useRouter } from "@edreamsodigeo/frontend-core";

import { PriceBreakdownPage } from "~/generated/graphql";

export const CHECKOUT_PAYMENT_PATH = "checkout_payment";
export const CHECKOUT_PASSENGERS_PATH = "checkout_passengers";

const useGetPriceBreakDownPage = (): PriceBreakdownPage | undefined => {
  const { pathname } = useRouter();
  let requestPage: PriceBreakdownPage | undefined = undefined;

  if (pathname.includes(CHECKOUT_PAYMENT_PATH)) {
    requestPage = PriceBreakdownPage.Payment;
  }

  if (pathname.includes(CHECKOUT_PASSENGERS_PATH)) {
    requestPage = PriceBreakdownPage.Passengers;
  }

  return requestPage;
};

export default useGetPriceBreakDownPage;
